<template>
  <div class="d-flex flex-column gap-4 p-relative">
    <form
      v-if="csrf"
      action="/users/auth/facebook"
      method="post">
      <input
        type="hidden"
        name="authenticity_token"
        :value="csrf" />
      <v-btn
        class="facebook-btn"
        :style="{ border: `1px solid black`, backgroundColor: 'white' }"
        block
        type="submit"
        height="48px"
        depressed>
        <div class="icon mb-1 mr-2">
          <img
            :width="10"
            :height="19"
            src="@/assets/img/button_social/icon_facebook.png" />
        </div>
        <span class="text-description blank--text font-weight-bold">
          เข้าสู่ระบบด้วย Facebook
        </span>
      </v-btn>
    </form>
    <v-chip
      class="recommend-button pa-2"
      color="error"
      rounded>
      แนะนำ !
    </v-chip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    disabled: Boolean
  },
  data () {
    return {
      submitting: false
    }
  },
  computed: {
    ...mapGetters({
      csrf: 'auth/csrf'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.icon {
  width: 20px;
  height: 20px;
}
@media #{map-get($display-breakpoints, 'lg-only')} {
  .facebook-btn {
    max-height: 40px;
  }
}
.recommend-button {
  position: absolute;
  top: -16px;
  left: -32px;
}
</style>
